export default __webpack_public_path__ + "static/media/oblaci.804075ca.png";